module.exports = __webpack_public_path__ + "static/media/back11.a2e8ed19.jpg";